"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addProtocolAndEscape = exports.addHttpsProtocol = exports.removeProtocolAndWww = void 0;
const regexes_1 = require("root/src/shared/util/regexes");
const removeProtocolAndWww = (url) => {
    try {
        return url.replace(regexes_1.httpsWwwRe, '');
    }
    catch (_) {
        return undefined;
    }
};
exports.removeProtocolAndWww = removeProtocolAndWww;
const addHttpsProtocol = (url) => {
    try {
        return url.replace(regexes_1.httpsWwwRe, 'https://');
    }
    catch (_) {
        return undefined;
    }
};
exports.addHttpsProtocol = addHttpsProtocol;
const addProtocolAndEscape = (url) => {
    try {
        return `https%3A%2F%2F${url.replace(/\//g, '%2F')}`;
    }
    catch (_) {
        return undefined;
    }
};
exports.addProtocolAndEscape = addProtocolAndEscape;
